import useMount from 'core/hooks/useMount';
import React, {PropsWithChildren, useState} from 'react';

export const ClientOnly = ({children}: PropsWithChildren) => {
    const [hasMounted, setHasMounted] = useState<boolean>(false);

    useMount(() => setHasMounted(true));

    if (!hasMounted) {
        return null;
    }

    return <>{children}</>;
};
